module.exports = __webpack_public_path__ + "img/telegram.f9d786e8.svg";